import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
  styleUrls: ['./experience.component.scss']
})
export class ExperienceComponent implements OnInit {
  experienceList = [
    {
      employer_name: "Jio",
      website: "https://www.jio.com/",
      start_date: new Date(2021, (3 - 1), 15, 0, 0, 0, 0),
      end_date: DatewithoutTime(new Date()),
      current_emp: true,
      roles: [
        {
          name: "Software Developer",
          role_start_date: new Date(2021, (3 - 1), 15, 0, 0, 0, 0),
          role_end_date: DatewithoutTime(new Date()),
          responsibilities: [
            "To Build the front-end of applications and Write effective APIs (both reusable and performance-oriented).",
            "To Write a MongoDB query in an optimized way.",
            "To Learn advanced Nodejs concepts to improve API performance.",
            "Keeping current with industry trends and developments that can be applied to application and company needs."
          ]
        }

      ]

    },
    {
      employer_name: "Aagnia Technologies",
      website: "https://aagnia.com/",
      start_date: new Date(2018, (6 - 1), 11, 0, 0, 0, 0),
      end_date: new Date(2021, (3 - 1), 11, 0, 0, 0, 0),
      current_emp: false,
      roles: [
        {
          name: "Full Stack Developer",
          role_start_date: new Date(2018, (11 - 1), 1, 0, 0, 0, 0),
          role_end_date: new Date(2021, (3 - 1), 11, 0, 0, 0, 0),
          responsibilities: [
            "Designed client-side and server-side architecture (both Multi-Tenant and Single-Tenant) based on application and customer needs.",
            "Builded the front-end of applications and Write effective APIs (both reusable and performance-oriented).",
            "Worked both Server and Serverless Technology(with Lambda and Api gateway).",
            "Writing Unit Test cases as part of CI/CD.",
            "Maintaining Clear technical documentation during development.",
            "Keeping current with industry trends and developments that can be applied to application and company needs."
          ]
        },
        {
          name: "Ui Developer",
          role_start_date: new Date(2018, (6 - 1), 11, 0, 0, 0, 0),
          role_end_date: new Date(2018, (11 - 1), 1, 0, 0, 0, 0),
          responsibilities: [
            "Worked on website development, enhancements, maintenance, browser testing and debugging.",
            "Leveraged responsive web frameworks to consistently complete product delivery ahead of schedule.",
            "Worked with manual filters in the website during enhancements and debugging.",
            "Analyzed browser speed and performance by using chrome dev tools."
          ]
        }
      ]

    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
function DatewithoutTime(dateTime) {
  var date = new Date(dateTime.getTime());
  date.setHours(0, 0, 0, 0);
  return date;
}
